<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  computed: {
    isSignIn () {
      return this.$store.state.isSignIn
    }
  },
  watch: {
    isSignIn() {
      if (this.$store.state.isSignIn && this.isVersionUp()) {
        this.$swal({
          title: 'アップデート v' + this.$version,
          html: `
          <div class='update' align='left'>
            <h3>不具合修正</h3>
            <ul>
              <li>管理画面 (管理者向け)</li>
              <ul>
                <li>組織設定</li>
                <ul>
                  <li>メンバーのインポートが表示されない場合がある不具合の修正</li>
                </ul>
              </ul>
            </ul>
          </div>`,
          icon: 'info',
          width: '700px'
        })
        localStorage.setItem('version', this.$version)
      }
    },
  },
  methods: {
    /**
     * バージョンアップがあったかどうか
     * @returns {Boolean} バージョンアップがあったならばTrue
     */
    isVersionUp() {
      const latestVersion = this.$version
      const previousVersion = localStorage.getItem('version')

      // 以前のバージョンが取得出来ない場合はバージョンアップがあったこととする
      if (previousVersion === null) {
        return true
      }
      // 最新バージョンの方が以前のバージョンよりも高いかどうか
      return (latestVersion.localeCompare(previousVersion, undefined, {numeric: true}) === 1)
    }
  }
}
</script>

<style scoped>
#app {
  font-family: 'Roboto', sans-serif;
}
</style>

<style>
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
::-webkit-scrollbar-track {
  background-color: #fefefe;
}
::-webkit-scrollbar-thumb {
  background-color: #939393;
  border: 2px solid #f9f9f9;
}
</style>



// WEBPACK FOOTER //
// src/App.vue